
import { Link } from 'react-router-dom';

export default function PolicyHero() {
  return (
    <header className="relative min-h-[50vh] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/16caba3adfed324ec4cc348f5ebb3b6b.jpg"
          alt="Daliah Secret Shipping and Returns"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/65 via-black/50 to-black/35"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full">
        <nav className="mb-8" aria-label="Breadcrumb">
          <ol className="flex items-center gap-2 text-sm text-white/70">
            <li>
              <Link to="/" className="hover:text-white transition-colors cursor-pointer">Home</Link>
            </li>
            <li><i className="ri-arrow-right-s-line text-white/40"></i></li>
            <li className="text-white">Shipping &amp; Returns</li>
          </ol>
        </nav>
        <p className="text-[#A5D6A7] text-sm tracking-[0.3em] mb-4 font-medium">CUSTOMER CARE</p>
        <h1 className="text-5xl font-serif text-white mb-5 leading-tight">
          Shipping &amp; Returns
        </h1>
        <p className="text-white/80 text-lg font-light max-w-xl leading-relaxed">
          We want every Daliah Secret experience to be seamless — from the moment you order to the moment you unwrap your treasures.
        </p>
      </div>
    </header>
  );
}
